import React from 'react';
import './Reviews.css';
import { FaStar, FaGoogle } from 'react-icons/fa';

const reviewsData = [
  {
    author: "João Silva",
    text: "Atendimento nota 10! Chegaram rápido e resolveram meu problema com profissionalismo. A bateria nova ficou excelente.",
    rating: 5,
  },
  {
    author: "Maria Oliveira",
    text: "Levei o carro para trocar a bateria e fizeram o serviço com scanner, tudo certinho. Preço justo e equipe muito atenciosa. Recomendo!",
    rating: 5,
  },
  {
    author: "Carlos Pereira",
    text: "Melhor loja de baterias da região de Sarzedo e região metropolitana de Belo Horizonte. Confiança total no serviço do Grupo Metropolitana.",
    rating: 5,
  },
];

const StarRating = ({ rating }) => {
  const stars = [];
  for (let i = 0; i < 5; i++) {
    stars.push(<FaStar key={i} color={i < rating ? '#ffc107' : '#e4e5e9'} />);
  }
  return <div className="star-rating">{stars}</div>;
};

const Reviews = () => {
  return (
    <section className="reviews-section">
      <div className="container">
        <h2 className="section-title">O que Nossos Clientes Dizem</h2>
        <div className="reviews-grid">
          {reviewsData.map((review, index) => (
            <div className="review-card" key={index}>
              <div className="review-header">
                <div className="review-author-info">
                  <h4>{review.author}</h4>
                  <StarRating rating={review.rating} />
                </div>
                <FaGoogle className="review-source-icon" />
              </div>
              <p className="review-text">"{review.text}"</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Reviews;